import { styled, keyframes } from '@stitches/configed';

const skBounce = keyframes({
  '0%,80%,100%': { transform: 'scale(0)' },
  '40%': { transform: 'scale(1)' },
});

const SKThreeBounce = styled('div', {
  width: '100%',
  height: '100%',
  borderRadius: 10,
  textAlign: 'center',
  // backgroundColor: '$surface1', // fix the background color is white but the Modal background color is diff
});
const Bounce = styled('div', {
  position: 'relative',
  top: '50%',
  transform: 'translateY(-50%)',
  width: 20,
  height: 20,
  backgroundColor: '$brand',
  borderRadius: '100%',
  display: 'inline-block',
  animation: `${skBounce} 1.4s ease-in-out 0s infinite both`,

  variants: {
    number: {
      1: {
        animationDelay: '-0.32s',
      },
      2: {
        animationDelay: '-0.16s',
      },
      3: {},
    },
  },
});
const LoadingScreen = () => {
  return (
    <SKThreeBounce>
      <Bounce number="1" />
      <Bounce number="2" />
      <Bounce number="3" />
    </SKThreeBounce>
  );
};

export default LoadingScreen;
